import React from 'react';
import { useEffect } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Segment, Header, Container } from 'semantic-ui-react';
import { searchContent } from '@plone/volto/actions';
import { UniversalLink, Image } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { keys, isEmpty } from 'lodash';
import { Carousel } from '../';


const SLIDE_OPTIONS = {
    loop: false,
    autoplay: false,
    dots: true,
    buttons: true,
    customClass: 'banners-slider',
    stopOnMouseEnter: true,
    slidesToScroll: 1,
    breakpoints: {
        '(min-width: 768px)': { slidesToScroll: 2 },
        '(min-width: 992px)': { slidesToScroll: 4 },
    }
}

const ItemView = props => {
    const { item } = props

    return (
        <>
            {item.getRemoteUrl ? (
                <UniversalLink href={item.remoteUrl} className=" bannerItem " key={item['@id']}>
                    <figure className="bannerItem__wrapper m-0">
                        <Image
                            item={item}
                            className="bannerItem__image image ui"
                            alt={item.title}
                            sizes="(max-width: 767px) 100vw, (max-width: 991px) 25rem, (max-width: 1279px) 20rem, 25rem"
                        />
                    </figure>
                </UniversalLink>
            ) : (
                <UniversalLink href={flattenToAppURL(item['@id'])} className=" bannerItem " key={item['@id']}>
                    <figure className="bannerItem__wrapper m-0">
                        <Image
                            item={item}
                            className="bannerItem__image image ui"
                            alt={item.title}
                            sizes="(max-width: 767px) 100vw, (max-width: 991px) 25rem, (max-width: 1279px) 20rem, 25rem"
                        />
                    </figure> 
                </UniversalLink>
            )}
        </>
    )

};

const Banners = (props) => {
    const dispatch = useDispatch();
    const banners = useSelector((state) => state.search.subrequests.banners?.items);

    useEffect(() => {
        dispatch(
            searchContent(
                '/portada/banners',
                {
                    portal_type: ['Banner'],
                    sort_on: 'getObjPositionInParent',
                    metadata_fields: ['getRemoteUrl', 'remoteUrl']
                },
                'banners',
            ),
        );
    }, [dispatch]);

    return (
        <>
            {!isEmpty(banners) && (
                <section className="bannersFooter d-print-none" >

                    <Container>

                        <Header as="h2" className='bannersFooter__title'>
                            <FormattedMessage id="Tambe et pot interessar" defaultMessage='Tambe et pot interessar' />
                        </Header>

                        <Carousel slides={banners.slice(0, 8)} ItemView={ItemView} options={SLIDE_OPTIONS} />

                    </Container>

                </section>
            )}
        </>
    );
};


export default Banners;